/*
 * @Date: 2020-07-07 16:44:06
 * @Author: lyb
 * @LastEditors: lyb
 * @LastEditTime: 2020-08-24 10:13:00
 */

export default {
    install (Vue, options) {
        // 接收一个对象及对象内不需要的key，此函数会将其转为undefined
        // 返回处理后的对象
        Vue.prototype.changeSomeKeyByUndefined = (obj, aryKeys = []) => {
            const target = {}

            Object.keys(obj).forEach((o, index) => {
                if (obj.hasOwnProperty(aryKeys[o])) {
                    target[aryKeys[index]] = undefined
                }
            })
            return Object.assign(obj, target)
        }

        /**
         * @param { objKeys } 接收一个需要转为对象的数组key
         * @returns { object } key是数组每一项，value都是undefined
         */
        Vue.prototype.transformKeyToUndefined = (objKeys = []) => {
            const target = {}
            objKeys.forEach(key => {
                target[key] = undefined
            })
            return target
        }

        /**
         *
         * @param { Array } arr 需要去重的数组
         * @param { Array } name 重复的数组内的key
         */
        Vue.prototype.uniqueObject = (arr, name) => {
            var hash = {}
            return arr.reduce(function(item, next) {
                let key = ''
                name.forEach(value => {
                    key += next[value]
                })
                // eslint-disable-next-line no-unused-expressions
                hash[key] ? '' : (hash[key] = true && item.push(next))
                return item
            }, [])
        }

        /**
         *
         * @param { Object } stringObj key全是string<number>类型的对象
         * @example {
         *  s: '2',
         *  d: '21',
         *  c: '333'
         * }
         * @returns key全是数字类型的对象
         */
        Vue.prototype.transformKeyForNumber = stringObj => {
            const target = {}
            for (let k in stringObj) {
                target[k] = +stringObj[k]
            }
            return target
        }

        /**
         * @param { Object } source 源对象
         * @param { Object } transf 待复制的对象
         * @returns { Object } 返回仅包含待复制对象的key-value
         */
        Vue.prototype.transformNeedKeys = (source, transf) => {
            const result = {}
            const otKeys = Object.keys(transf)
            
            try {
                Object.keys(source).forEach(key => {
                    if (otKeys.includes(key || '')) {
                        result[key] = source[key]
                    }
                })
            } catch (error) {
                console.log(error)
            }
            

            return result
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/util/globalFunction.js